<section class="users-view">
	<!-- Media object starts -->
	<div class="row">
	  <div class="col-12 col-sm-7">
		<div class="media d-flex align-items-center">
		  <a href="javascript:;">
			<img
			  *ngIf="!courseData"
			  src="assets/MeanderLIVE-icon.png"
			  alt="user
			  view avatar"
			  class="users-avatar-shadow rounded"
			  height="64"
			  width="64"
			/>
			<img
			  *ngIf="courseData"
			  [src]="imageUrl+courseData.image"
			  alt="user
			  view avatar"
			  class="users-avatar-shadow rounded"
			  height="64"
			  width="64"
			/>
		  </a>
		  <div class="media-body ml-3">
			<h4>
			  <span class="users-view-name mr-1">{{
				courseData?.title
			  }}</span>
			  <!-- <span class="text-muted font-medium-1">
				  <span>@</span>
				  <span class="users-view-username">dean3004</span>
				</span> -->
			</h4>
			<span class="mr-1">ID:</span>
			<span class="users-view-id">{{
			  courseData?._id.substring(courseData?._id.length - 6)
			}}</span>
		  </div>
		</div>
	  </div>
	  <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
		<!-- <a
		  href="javaScript:void(0);"
		  class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
		  ><i class="ft-mail"></i
		></a>
		<a
		  href="javaScript:void(0);"
		  class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
		  >Profile</a
		> -->
		<a
		  [routerLink]="['/course/course-edit', courseData?._id]"
		  class="btn btn-sm btn-primary px-3 py-1"
		  >Edit</a
		>
	  </div>
	</div>
	<!-- Media object ends -->
  
	<div class="row">
	  <div class="col-12">
		<!-- Card data starts -->
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <div class="row">
				<div class="col-12 col-xl-4">
				  <table class="table table-borderless">
					<tbody>
					  <tr class='d-flex'>
						<td>Name :</td>
						<td>{{ courseData?.title }}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>About :</td>
						<td>{{ courseData?.about }}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Fees :</td>
						<td>{{ courseData?.total_fees | currency:'INR':'symbol' }}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Min Fees :</td>
						<td>{{ courseData?.minfees | currency:'INR':'symbol' }}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Max Fees :</td>
						<td>{{ courseData?.maxfees | currency:'INR':'symbol' }}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Registered :</td>
						<td>{{ courseData?.created_at | date: "mediumDate" }}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Latest Activity :</td>
						<td class="users-view-latest-activity">
						  {{ courseData?.updated_at | date: "mediumDate" }}
						</td>
					  </tr>
					 
					</tbody>
				  </table>
				</div>
			  </div>
			</div>
		  </div>
		</div>
		<!-- Card data ends -->
	  </div>
	  <div class="col-12">
		<!-- User detail starts -->
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <div class="col-12">
				<div class="table-responsive">
				  <table class="table table-borderless">
					<tbody>
					  <h5 class="mb-2 text-bold-500">
						<i class="ft-info mr-2"></i> Course Info
					  </h5>
					  <tr class='d-flex'>
						<td>Announcements :</td>
						<td>{{ courseData?.announcements }}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Batch :</td>
						<td>
							<span *ngFor="let batch of courseData?.batch_ids; last as isLast">
								<span>{{batch?.name}}</span>
								<span *ngIf="batch?.name?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Benifits :</td>
						<td [innerText]="courseData?.benifits"></td>
					  </tr>
					  <tr class='d-flex'>
						<td>Course Category :</td>
						<td>
							<span *ngFor="let item of courseData?.course_category; last as isLast">
								<span>{{item?.displayname}}</span>
								<span *ngIf="item?.displayname?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Category :</td>
						<td>
							<span *ngFor="let item of courseData?.category; last as isLast">
								<span>{{item?.displayname}}</span>
								<span *ngIf="item?.displayname?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Course Skill :</td>
						<td>
							<span *ngFor="let skill of courseData?.course_skills; last as isLast">
								<span>{{skill?.displayname}}</span>
								<span *ngIf="skill?.displayname?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>                   
					  <tr class='d-flex'>
						<td>Course Tag :</td>
						<td>
							<span *ngFor="let item of courseData?.course_tags; last as isLast">
								<span>{{item?.displayname}}</span>
								<span *ngIf="item?.displayname?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Duration :</td>
						<td>
							<span *ngFor="let item of courseData?.duration; last as isLast">
								<span>{{item?.displayname}}</span>
								<span *ngIf="item?.displayname?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Course Type :</td>
						<td>{{courseData?.course_type}}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Level :</td>
						<td>{{courseData?.level}}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Mode :</td>
						<td>{{courseData?.mode}}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Variations :</td>
						<td>
							<span *ngFor="let item of courseData?.variations; last as isLast">
								<span>{{item?.displayname}}</span>
								<span *ngIf="item?.displayname?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Instructor :</td>
						<td>
							<span *ngFor="let item of courseData?.instructor; last as isLast">
								<span>{{item?.user[0]?.name}}</span>
								<span *ngIf="item?.user[0]?.name?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Proof Readers :</td>
						<td>
							<span *ngFor="let item of courseData?.proofreaders; last as isLast">
								<span>{{item?.user[0]?.name}}</span>
								<span *ngIf="item?.user[0]?.name?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Publishers :</td>
						<td>
							<span *ngFor="let item of courseData?.publishers; last as isLast">
								<span>{{item?.user[0]?.name}}</span>
								<span *ngIf="item?.user[0]?.name?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Last Published By :</td>
						<td>
							<span *ngFor="let item of courseData?.last_published_by; last as isLast">
								<span>{{item?.user[0]?.name}}</span>
								<span *ngIf="item?.user[0]?.name?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Resources :</td>
						<td>
							<span *ngFor="let item of courseData?.resources; last as isLast">
								<span>{{item?.content}}</span>
								<span *ngIf="item?.content?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Projects :</td>
						<td>
							<span *ngFor="let item of courseData?.projects; last as isLast">
								<span>{{item?.name}}</span>
								<span *ngIf="item?.name?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Offers :</td>
						<td>
							<span *ngFor="let item of courseData?.offers; last as isLast">
								<span>{{item?.displayname}}</span>
								<span *ngIf="item?.displayname?.length>1 && !isLast">&nbsp;,&nbsp;</span>
							</span>
						</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Certification :</td>
						<td>{{courseData?.certification}}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Grading :</td>
						<td>{{courseData?.grading}}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Language :</td>
						<td>{{courseData?.language}}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Objective :</td>
						<td>{{courseData?.objective}}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Outcome :</td>
						<td>{{courseData?.outcome}}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Preliminary :</td>
						<td>{{courseData?.preliminary}}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Promotional Video :</td>
						<td>{{courseData?.promotional_video}}</td>
					  </tr> 
					  <tr class='d-flex'>
						<td>Service And Offer :</td>
						<td>{{courseData?.serviceandoffer}}</td>
					  </tr> 
					  <tr class='d-flex'>
						<td>Learning Audience :</td>
						<td>{{courseData?.learning_audience}}</td>
					  </tr> 
					  <tr class='d-flex'>
						<td>Version :</td>
						<td>{{courseData?.version}}</td>
					  </tr> 
					  <tr class='d-flex'>
						<td>Published App :</td>
						<td>{{courseData?.published_app}}</td>
					  </tr> 
					  <tr class='d-flex'>
						<td>Published Web :</td>
						<td>{{courseData?.published_web}}</td>
					  </tr> 
					  <tr class='d-flex'>
						<td>Published Datetime :</td>
						<td>{{courseData?.published_datetime | date:'mediumDate'}}</td>
					  </tr>
					  <tr class='d-flex'>
						<td>Notes :</td>
						<td [innerText]="courseData?.notes"></td>
					  </tr>
					  <tr class='d-flex'>
						<td>Admin Notes :</td>
						<td [innerText]="courseData?.admin_notes"></td>
					  </tr>
					  
  
					  <!-- <tr class='d-flex'>
						  <td>E-mail:</td>
						  <td>{{courseData?.email}}</td>
						</tr> -->
					</tbody>
				  </table>
				</div>
  
				<!-- <tr class='d-flex'>
						  <td>Contact:</td>
						  <td>{{userData?.phoneNumber}}</td>
						</tr> -->
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	  <!-- User detail ends -->
	</div>
  </section>
  